import styled from "styled-components"

const CollectionOverview = styled.div`
    padding:50px 0 50px 0;
    display:flex;
    flex-direction:column;
    margin: 0 auto;
    width:80%;
    @media(max-width:500px ){
        width:100%;
    }
`
export default CollectionOverview